import { baseResources, baseResourceActions } from "routes/enum";

const { INTEGRATION_GMAIL, AGENTS_INBOX_BASE_SETTING } = baseResources;
const { CREATE, READ } = baseResourceActions;

/** Connect Gmail channel */
export const GMAIL_INTEGRATION_CREATE_PERMISSION = [
    `${CREATE}_${INTEGRATION_GMAIL}`,
];

/** View integrations settings tab (inbox settings read or Gmail connect) */
export const INTEGRATIONS_PAGE_ACCESS_PERMISSION = [
    `${READ}_${AGENTS_INBOX_BASE_SETTING}`,
    ...GMAIL_INTEGRATION_CREATE_PERMISSION,
];

export const INTEGRATIONS_PERMISSION_MAP = {
    "Connect Gmail channel": GMAIL_INTEGRATION_CREATE_PERMISSION,
};
